import { convertText } from "@/hooks/utils";
import { LessonDataI } from "../../../quiz/typesAndEnums";
import LessonCountdown from "../../LessonCountdown";

const LessonPageHead = ({ lessonData }: { lessonData: LessonDataI }) => {
  return (
    <div id="lesson-page-head" className="px-4 pb-4 flex flex-col gap-5">
      <h1 className="text-3xl font-bold text-gray-900">{convertText(lessonData.title)}</h1>

      {lessonData.is_purchased && !lessonData.is_author && (
        <div className="flex flex-col md:flex-row gap-4 mt-4">
          {lessonData.expiry_date !== -1 && (
            <div className="w-full md:w-1/2 mx-auto mt-2 py-2 px-4 bg-red-100 border border-red-400 text-red-700 rounded-lg">
              <LessonCountdown targetDate={lessonData.expiry_date} />
            </div>
          )}

          {lessonData.remaining_views !== -1 && (
            <div
              style={{ height: "fit-content" }}
              className="w-full md:w-1/2 mx-auto mt-2 py-2 px-4 bg-blue-100 border border-blue-300 text-primary rounded-lg"
            >
              {`مرات المشاهدة المتبقية (${
                lessonData.remaining_views < 1
                  ? "نفذت المشاهدات"
                  : lessonData.remaining_views
              })`}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default LessonPageHead;
